<template>
  <div class="hy-order">
    <div class="order-cont" v-show="adminShow">
      <!--活动简介-->
      <div class="order-topTitle" v-if="conference.name">
        <div class="title">
          <h5>{{conference.name}}</h5>
        </div>
        <div class="info_info">
          <span class="icon" v-if="cartbox.carNumPrice.conf_ticket_num == 0">平行会议</span>
        </div>
        <div class="infotimes" style="margin-top:10px;" v-if="conference.organizers != ''">
          <span class="iconfont">&#xe671;</span>主办单位：{{conference.organizers}}
        </div>
        <!-- <div class="infotimes" v-if="conference.company != ''">
          <span class="iconfont">&#xe6bb;</span>承办单位：{{conference.company}}
        </div> -->
        <div class="infotimes infotimes_width_label_content" style="display: flex;" v-if="id != '5664' && conference.company != ''">
          <div class="label" style="white-space: nowrap">
              <span class="iconfont">&#xe6bb;</span>
              <span>承办单位：</span>
            </div>
            <div class="content" style="display: flex; flex-direction: column; flex: auto;">
              <div v-for="(i, index) in conference.company?.split(' ')" :key="index">{{ i }}</div>
            </div>
        </div>
        <div class="infotimes">
          <span class="iconfont">&#xe67f;</span>会议时间：{{conference.start_time,'Y-M-D'|formatDates}}~{{conference.end_time,'Y-M-D'|formatDates}}
        </div>
        <div class="infotimes">
          <span class="iconfont">&#xe64d;</span>会议地点：{{conference.region}}{{conference.specific_address}}
        </div>
      </div>
      <br>
      <!--订单归属-->
      <van-field class="guishu" v-model="addUserPhone" label="订单归属" placeholder="请输入订单归属人手机号" maxlength="11"  />


      <!-- 填写购票信息-->
      <div class="order-addPeople" v-if="cartbox.carNumPrice.conf_ticket_num > 0">
        <h5>为保证报名信息的准确性，请您认真填写参会人信息</h5>
        <!--循环票种类-->
        <template v-for="(piao,piao_index) in cartbox.conf_ticket_arr">
          <div class="add_items" v-for="(items2,p_index) in piao.member">
            <!--循环各类型票的购买数量-->
            <div class="add_top">
              <div class="l">
                <p>第 {{items2.piao_num}} 位参会人信息</p>
                <p class="name">{{piao.name}}</p>
              </div>
              <div class="r">
                <!--<span class="add_btn">保存</span>-->
              </div>
            </div>
            <div class="add_box">
              <!-- 循环字段-->
              <div v-for="(items,index) in field_box" :key="index">
                <!--出版图书判断单加-->
                <template v-if="conference.id == 5123 &&  items.form_type == 7">
                  <!-- 搜索选择-->
                  <van-field :class="items2.filed[index].is_click ? '':'active'" v-show="items2.chuban === 0" v-model="items2.filed[index].value" :label="items.field + '：'" :placeholder="items.tips ? items.tips : '点击选择' " @click="showZdybox(piao_index,p_index,index)" readonly />
                  <van-field :class="items2.filed[index].is_click ? '':'active'" v-show="items2.chuban === 1" v-model="items2.filed[index].value" :label="items.field + '：'" placeholder="请输入内容" :maxlength="items.maxlength == 0 ? '100': items.maxlength" @blur="validator(piao_index,p_index,index)" />
                </template>
                <template v-else>
                  <!-- 搜索选择-->
                  <van-field :class="items2.filed[index].is_click ? '':'active'" v-if="items.form_type == 7" v-model="items2.filed[index].value" :label="items.field + '：'" :placeholder="items.tips ? items.tips : '点击选择' " @click="showZdybox(piao_index,p_index,index)" readonly />
                  <!-- 文本输入框-->
                  <van-field :class="items2.filed[index].is_click ? '':'active'" v-else-if="items.form_type == 1" v-model="items2.filed[index].value" :label="items.field + '：'" :placeholder="items.tips ? items.tips : '请输入内容' " :maxlength="items.maxlength == 0 ? '100': items.maxlength" @blur="validator(piao_index,p_index,index)" />
                  <!--多行文本-->
                  <van-field :class="items2.filed[index].is_click ? '':'active'" v-else-if="items.form_type == 2" rows="2" type="textarea" :maxlength="items.maxlength == 0 ?'':items.maxlength" v-model="items2.filed[index].value" show-word-limit :label="items.field + '：'" :placeholder="items.tips ? items.tips : '请输入内容'" style="height:auto;" @blur="validator(piao_index,p_index,index)" />
                  <!-- 单选框 -->
                  <div class="van-radio-groupBox" :class="items2.filed[index].is_click ? '':'active'" v-else-if="items.form_type == 3">
                    <h5>{{items.field}}：</h5>
                    <van-radio-group v-model="items2.filed[index].value" direction="horizontal" @change="checkedChang(piao_index,p_index,index)">
                      <!--循环单选框-->
                      <van-radio :name="optionsItems" v-for="optionsItems in items.options">{{optionsItems}}</van-radio>
                    </van-radio-group>
                  </div>
                  <!-- 复选框 -->
                  <div class="van-radio-groupBox" :class="items2.filed[index].is_click ? '':'active'" v-else-if="items.form_type == 4">
                    <h5>{{items.field}}：</h5>
                    <van-checkbox-group v-model="items2.filed[index].value" direction="horizontal" @change="checkedChang(piao_index,p_index,index)">
                      <van-checkbox shape="square" :name="optionsItems" v-for="optionsItems in items.options">{{optionsItems}}</van-checkbox>
                    </van-checkbox-group>
                  </div>
                  <!--下拉选择-->
                  <div class="van-select-groupbox" :class="items2.filed[index].is_click ? '':'active'" v-else-if="items.form_type == 5">
                    <div class="van-select-label">
                      {{items.field}}：
                    </div>
                    <van-dropdown-menu>
                      <van-dropdown-item v-model="items2.filed[index].value" :title="items2.filed[index].value =='' ? '请选择':''" :options="items.options" @change="checkedChang(piao_index,p_index,index)">
                      </van-dropdown-item>
                    </van-dropdown-menu>
                  </div>
                  <!--选择日期-->
                  <div class="van-check-time" :class="items2.filed[index].is_click ? '':'active'" v-else-if="items.form_type == 6">
                    <van-cell :title="items.field+'：'" :value="items2.filed[index].value == '' ? '请选择' : items2.filed[index].value" @click="open_datetimePicker([piao_index,p_index,index],'date')" />
                  </div>
                  <div class="add_box_title" v-else-if="items.form_type == 8">
                    {{items2.filed[index].name}}
                  </div>
                </template>
              </div>
              <div>
                <van-checkbox v-model="items2.main" @click="changeZy(piao_index,p_index)">设为主要联系人</van-checkbox>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!--选择部门-->
      <div class="order_bumen" v-if="bumen.length > 0">
        <!--下拉选择-->
        <div class="van-select-groupbox">
          <div class="van-select-label">
            联系部门
          </div>
          <van-dropdown-menu>
            <van-dropdown-item v-model="bumenOn" :title="bumenOn === '' ? '请选择':bumen[bumenOn].text" :options="bumen">
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
      </div>
      <!--平行会议列表-->
      <div class="order_piaozhong" v-if="parallel.list.length > 0">
        <div class="pz_title">
          <h5>是否参加平行会议</h5>
          <van-radio-group v-model="parallel.isIn" direction="horizontal" @change="changPiao()">
            <van-radio name="1" shape="square">是</van-radio>
            <van-radio name="0" shape="square">否</van-radio>
          </van-radio-group>
        </div>
        <div class="order_cell" v-if="parallel.isIn == '1'">
          <div class="order_cell_items" v-for="(items,index2) in parallel.list" :key="index2">
            <div class="order_pxTitle">
              <h5 class="pxTitle"><span></span>{{items.name}}</h5>
              <div class="infotimes">
                <span class="iconfont">&#xe67f;</span>{{items.start_time,'Y-M-D'|formatDates}}~{{items.end_time,'Y-M-D'|formatDates}}
              </div>
              <div class="infotimes">
                <span class="iconfont">&#xe64d;</span>{{items.region}}{{items.specific_address}}
              </div>
            </div>
            <div class="piao_list">
              <div class="piao_items" v-for="(items2,index3) in items.ticket" :key="index3">
                <h5 class="piao_name">{{items2.ticket_name}}</h5>
                <div class="piao_numbox">
                  <div class="l">
                    <span class="piao_price">￥{{items2.price}}/1人</span>
                  </div>
                  <div class="r">
                    <!--通过设置disabled属性来禁用步进器 integer  整数设置-->
                    <van-stepper v-model="cartbox.parallel_ticket_arr[index2].ticket[index3].quantity" min="0" :max="cartbox.parallel_ticket_arr[index2].ticket[index3].max_num" integer @change="change(cartbox.parallel_ticket_arr[index2].ticket[index3])" @overlimit="overlimit(cartbox.parallel_ticket_arr[index2].ticket[index3])" disable-input />
                    <span class="piao_num">剩余{{cartbox.parallel_ticket_arr[index2].ticket[index3].remaining_num - cartbox.parallel_ticket_arr[index2].ticket[index3].quantity}}个名额</span>
                  </div>
                </div>
                <div class="piao_info">
                  {{items2.desc == ''?'暂无说明':items2.desc}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--是否住宿-->
      <div class="order_piaozhong" v-if="hotel.list.length > 0">
        <div class="pz_title">
          <h5>是否住宿</h5>
          <van-radio-group v-model="hotel.isIn" direction="horizontal" @change="changPiao()">
            <van-radio name="1" shape="square">是</van-radio>
            <van-radio name="0" shape="square">否</van-radio>
          </van-radio-group>
        </div>
        <div class="order_cell" v-if="hotel.isIn == '1'">
          <div class="order_cell_items" v-for="(items,index) in hotel.list" :key="index">
            <div class="order_pxTitle" :class="cartbox.hotel[index].isShow == 1 ?'active':''" @click="hotelClick(index)">
              <h5 class="px_left"><span></span>{{items.name}}</h5>
              <span class="iconfont zs_icon" v-html="cartbox.hotel[index].isShow == 1 ? '&#xe60f;':'&#xe614;'"></span>
            </div>
            <div class="piao_list" v-if="cartbox.hotel[index].isShow == 1">
              <div class="piao_items" v-for="(items2,index2) in items.room" :key="index2">
                <h5 class="piao_name">{{items2.hotel_type}}</h5>
                <div class="piao_numbox">
                  <div class="l">
                    <span class="piao_price" v-if="items2.price > 0">￥{{items2.price}}/间</span>
                    <span class="piao_price" v-else>预订</span>
                  </div>
                  <div class="r">
                    <!--通过设置disabled属性来禁用步进器 integer  整数设置-->
                    <van-stepper v-model="cartbox.hotel[index].list[index2].quantity" min="0" :max="cartbox.hotel[index].list[index2].max_num" integer @change="change(cartbox.hotel[index].list[index2])" @plus="hoteladd(index,index2)" @minus="hotelRem(index,index2)" disable-input />
                    <span class="piao_num">剩余
                      {{cartbox.hotel[index].list[index2].remaining_num - cartbox.hotel[index].list[index2].quantity}} 间房</span>
                  </div>
                </div>
                <div class="piao_info" v-if="cartbox.hotel[index].list[index2].quantity == 0" style="color:#ff0000;">
                  {{items2.explain == '' ?'暂无说明':items2.explain}}
                </div>
                <div class="piao_timeNameList" v-else>
                  <div class="tm_items" v-for="(items3,index3) in cartbox.hotel[index].list[index2].people_list" :key="index3">
                    <div class="p_title" v-if="index3 > 0">
                      请填写第 {{index3+1}} 间房入住人信息
                    </div>
                    <div class="p_times" @click="open_calendar([index,index2,index3],{type:'range',default_date:[items3.start_time,items3.end_time],max_range:''})">
                      <div class="t_l">
                        <h5>入住时间</h5>
                        <div>
                          <span>{{items3.start_time ,'M月D日'|formatDates}}</span>{{items3.start_time ,'周'|formatWeekDate}}
                        </div>
                      </div>
                      <div class="t_l">
                        <h5>离店时间</h5>
                        <div>
                          <span>{{items3.end_time,'M月D日'|formatDates}}</span>{{items3.end_time ,'周'|formatWeekDate}}
                        </div>
                      </div>
                      <div class="t_r">
                        共 {{items3.day}} 晚 <span class="iconfont">&#xe699;</span>
                      </div>
                    </div>
                    <div class="p_names">
                      <van-field :class="items3.is_required ?'':'active'" v-model="items3.name1" label="住宿人1：" placeholder="请填写入住人姓名" @blur="nameChange(index,index2,index3)" />
                      <van-field v-model="items3.name2" label="住宿人2：" placeholder="请填写入住人姓名" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--是否用餐-->
      <div class="order_piaozhong" v-if="repast.list.length > 0">
        <div class="pz_title">
          <h5>是否用餐</h5>
          <van-radio-group v-model="repast.isIn" direction="horizontal" @change="changPiao()">
            <van-radio name="1" shape="square">是</van-radio>
            <van-radio name="0" shape="square">否</van-radio>
          </van-radio-group>
        </div>
        <div class="order_cell" v-if="repast.isIn == 1">
          <div class="order_cell_items">
            <div class="piao_list">
              <div class="piao_items2" v-for="(items,index) in repast.list" :key="index">
                <h5 class="piao_name">{{items.repast_info.address}}</h5>
                <div class="piao_times">
                  <p class="piao_eatTime">就餐时间：{{items.repast_info.start_time ,'M月D日 h:m'|formatDates}}~{{items.repast_info.end_time,'M月D h:m'|formatDates}}</p>
                  <p class="piao_sheng">就餐席位：剩余 {{cartbox.repast[index].remaining_num - cartbox.repast[index].quantity}} 位</p>
                  <p class="piao_sheng">价格：￥{{items.repast_info.price}} 位</p>
                </div>
                <div class="piao_info">
                  就餐说明：{{items.repast_info.explain == ''? '暂无': items.repast_info.explain}}
                </div>
                <div class="piao_numbox">
                  <div class="l">
                    就餐人数：<span class="piao_num">{{cartbox.repast[index].quantity}}</span>人
                  </div>
                  <div class="r">
                    <!--通过设置disabled属性来禁用步进器 integer  整数设置-->
                    <van-stepper v-model="cartbox.repast[index].quantity" min="0" :max="cartbox.repast[index].remaining_num" integer @change="change(cartbox.repast[index])" disable-input />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--报名须知-->
      <div class="order_xuzhi">
        <div class="title">
          <h5>报名须知</h5>
        </div>
        <div class="xuzhi_info" v-html="conference.ticket_desc"> </div>
      </div>
    </div>
    <!--订单页底部提交栏-->
    <div class="order_addbtnbox">
      <div class="addbox">
        <div class="l" @click="show_orderBox()">
          <div class="top">合计：<span class="l_price">￥{{cartbox.carNumPrice.price}}</span></div>
          <div class="bottom">
            <span class="number">共 {{cartbox.carNumPrice.num}} 个名额</span>
            <span class="iconfont"><em>明细</em> &#xe61f;</span>
          </div>
        </div>
        <div class="r">
          <span class="order_btn" @click="addPiaoCont()">报名</span>
        </div>
      </div>
      <van-action-sheet v-model="order_show" title="订单明细">
        <div class="sheet_list" v-if="cartbox.carNumPrice.conf_ticket_num >0">
          <p>主会议</p>
          <ul>
            <li v-for="(items,index) in cartbox.conf_ticket_arr" :key="index" v-if="items.quantity > 0">
              <span class="name">{{items.name}}</span>
              <span class="price"><em>￥{{items.price}}</em> x {{items.quantity}}</span>
            </li>
          </ul>
        </div>
        <div class="sheet_list" v-if="parallel.isIn == '1'">
          <p>平行会议</p>
          <ul v-for="(items,index2) in cartbox.parallel_ticket_arr" :key="index2">
            <li v-for="(items2,index3) in items.ticket" :key="index3" v-if="items2.quantity > 0">
              <span class="name">{{items2.name}}</span>
              <span class="price"><em>￥{{items2.price}}</em> x {{items2.quantity}}</span>
            </li>
          </ul>
        </div>
        <div class="sheet_list" v-if="hotel.isIn == '1' || repast.isIn == '1'">
          <p>其他费用支出</p>
          <ul v-if="hotel.isIn == '1'" class="hotel">
            <template v-for="(items,index) in hotel.list">
              <template v-for="(items2,index2) in cartbox.hotel[index].list">
                <li v-if="items2.quantity > 0">
                  <span class="name">{{items.name}} - ({{items2.name}})</span>
                  <span class="price">{{items2.quantity}}间</span>
                  <div class="day_list">
                    <div class="day_items" v-for="(items3,index3) in items2.people_list">
                      <span class="days">{{items3.start_time,'Y-M-D'|formatDates}} ~ {{items3.end_time,'Y-M-D'|formatDates}}</span>
                      <span class="priceNum"><em>{{items2.price}}</em> x {{items3.day}}天</span>
                    </div>
                    <div class="tishi" v-if="items2.price == 0">
                      {{items.room[index2].explain}}
                    </div>
                  </div>

                </li>
              </template>
            </template>
          </ul>
          <ul v-if="repast.isIn == '1'">
            <template v-for="(items,index) in cartbox.repast">
              <li v-if="items.quantity > 0">
                <span class="name">就餐 - {{items.name}}</span>
                <span class="price"><em>￥{{items.price}}</em> x {{items.quantity}}位</span>
              </li>
            </template>
          </ul>
        </div>
      </van-action-sheet>
    </div>


    <!--DatetimePicker时间选择器-->
    <div class="dateTimePicker">
      <van-popup v-model="datetimePicke.show" :position="datetimePicke.position" style="z-index:2010!important;">
        <van-datetime-picker v-model="datetimePicke.default_date" :type="datetimePicke.type" :title="datetimePicke.title" :min-date="datetimePicke.min_date" :max-date="datetimePicke.max_date" @confirm="datetimePickerConfirm" @cancel="onCancel()" />
      </van-popup>
    </div>
    <!--Calendar 日历-->
    <div class="vanCalendar">
      <van-calendar v-model="vanCalendar.v_model" :type="vanCalendar.type" :title="vanCalendar.title" :min-date="vanCalendar.min_date" :max-date="vanCalendar.max_date" :default-date="vanCalendar.default_date" :poppable="vanCalendar.poppable" :show-confirm="vanCalendar.show_confirm" :confirm-text="vanCalendar.confirm_text" :position="vanCalendar.position" :close-on-click-overlay="vanCalendar.close_on_click_overlay" :max-range="vanCalendar.max_range" :range-prompt="vanCalendar.range_prompt" :allow-same-day="vanCalendar.allow_same_day" @confirm="calendar_confirm" style="z-index:2010!important;" />
    </div>
    <!--搜索下拉自定义字段选择-->
    <van-popup v-model="zdybox.show" class="zdyBox" round position="bottom" :style="{ height: '70%' }" closeable>
      <van-field v-model="zdybox.value" :placeholder="zdybox.placeholder" class="input" @keyup="zdySearchKeyUp" @input="zdySearchKeyUp" />
      <div class="list">
        <van-radio-group v-model="zdybox.radio" v-if="zdybox.list.length >0">
          <van-cell-group>
            <van-cell :title="item" clickable v-for="item in zdybox.list" @click="zdybox.radio = item">
              <template #right-icon>
                <van-radio :name="item" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <p v-else>{{zdybox.tishi}}</p>
      </div>
      <van-button class="buttonBtn" type="primary" block @click="zdyBaocun">保存选项</van-button>
    </van-popup>
  </div>
</template>


<script>
  import {
    formatDates,
    formatWeekDate
  } from "../../assets/js/date";
  export default {
    data() {
      return {
        id: '',
        order_show: false,
        footerNav: false,
        //DatetimePicker 时间选择
        datetimePicke: {
          show: false,
          type: 'datetime', //时间类型，可选值为 date time  year-month month-day
          title: '日历', //	顶部栏标题
          confirm_button_text: '确定', //确认按钮文字区间
          cancel_button_text: '取消', //取消按钮文字
          visible_item_count: '5', //	可见的选项个数
          min_date: new Date(new Date().getTime() - 365 * 10 * 24 * 3600 * 1000), //可选的最小时间，精确到分钟
          max_date: new Date(new Date().getTime() + 365 * 10 * 24 * 3600 * 1000), //可选的最大时间，精确到分钟
          position: 'bottom', //弹出位置，可选值为 top right left
          default_date: new Date(), //默认值
          isOndata: '', //数据
        },
        //日期选择公共配置
        vanCalendar: {
          type: 'single', //single表示选择单个日期， multiple表示选择多个日期， range表示选择日期区间
          title: '日期选择',
          min_date: new Date(), //最小日期
          max_date: new Date(new Date().getTime() + 90 * 24 * 3600 * 1000), //最大日期
          default_date: new Date(), //默认选中的日期 date|| date[时间戳]
          poppable: true, //是否以弹层的形式展示日历
          show_confirm: true, //是否展示确认按钮
          confirm_text: '确定', //按钮文字
          v_model: false, //是否显示日历弹窗
          position: 'bottom', //弹出位置，可选值为 top right left
          close_on_click_overlay: true, //是否在点击遮罩层后关闭
          max_range: '', //最多可选天数
          range_prompt: '选择天数不能超过 xx 天', //超过最多可选天数时的提示文案
          allow_same_day: false, //是否允许日期范围的起止时间为同一天
          isOndata: '',
        },
        //报名字段初始化数据
        field_box: {},
        //会议信息
        conference: {},
        //平行会议列表
        parallel: {
          isIn: '1',
          list: []
        },
        //酒店信息
        hotel: {
          isIn: '1',
          list: []
        },
        //用餐地点列表
        repast: {
          isIn: '0',
          list: []
        },
        //购物车信息
        cartbox: {
          carNumPrice: {
            num: 0,
            price: '0.00',
            conf_ticket_num: 0,
            parallel_ticket_num: 0,
            hotel_num: 0,
            repast_num: 0,
            conf_price: '0.00',
            parallel_price: '0.00',
            hotel_price: '0.00',
            repast_price: '0.00'
          },
          conf_ticket_arr: [],
          parallel_ticket_arr: [],
          hotel: [],
          repast: [],
          para_checked: '',
        },
        bumen: [],
        bumenOn: '',
        zdybox: {
          show: false,
          list: [],
          tishi: "没有搜索到您输入的选项",
          inputOn: [],
          value: '',
          radio: '',
          placeholder: ''
        },
        huifu: false,
        adminShow: false, //权限
        addUserPhone:'',//订单归属账号
      };
    },
    /* 时间过滤 */
    filters: {
      formatDates, //调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
      formatWeekDate //
    },
    created: function() {
      var _this = this;
      _this.id = parseInt(_this.$route.params.id);
      _this.adminMerber();
      var getShare = JSON.parse(sessionStorage.getItem('hy_shareData' + _this.id));
      if (getShare != null) {
        _this.$WXConfig.wxShowMenu({
          ifshare: true,
          that: _this,
          data: getShare
        });
      } else {
        _this.$WXConfig.wxShowMenu({
          ifshare: true,
          that: _this,
          data: ''
        });
      }
      var getStorage = JSON.parse(sessionStorage.getItem('huiyi_orderlist' + _this.id));
      if (getStorage == undefined) {
        _this.goPath('/addOrder01/' + _this.id);
      }
      if (getStorage && _this.id == getStorage.id) {
        _this.cartbox.carNumPrice = getStorage.cartbox.carNumPrice;
        _this.cartbox.conf_ticket_arr = getStorage.cartbox.conf_ticket_arr;
        _this.conference = getStorage.conference;
        _this.cartbox.carNumPrice.parallel_ticket_num > 0 ? _this.parallel.isIn = '1' : _this.parallel.isIn = '0';
        _this.cartbox.para_checked = getStorage.cartbox.para_checked;
        if (getStorage.cartbox.hotel) {
          _this.cartbox.hotel = getStorage.cartbox.hotel;
          _this.hotel.isIn = '1';
        }
        if (getStorage.cartbox.repast) {
          _this.cartbox.repast = getStorage.cartbox.repast;
          _this.repast.isIn = '1';
        }
        if (getStorage.cartbox.carNumPrice.conf_ticket_num == 0) {
          _this.cartbox.parallel_ticket_arr = getStorage.cartbox.parallel_ticket_arr;
        }
      }
      _this.loadEnroll();
      if (_this.conference.is_dep) {
        //  _this.getBumen();
      }
      var backEnroll = JSON.parse(sessionStorage.getItem('backEnroll' + _this.id));
      if (backEnroll != undefined) {
        _this.$dialog.confirm({
            title: '提示',
            message: '是否恢复上次编辑未完成数据？',
          })
          .then(() => {
            // on confirm
            _this.cartbox = backEnroll.cartbox;
            _this.bumenOn = backEnroll.bumenOn;
            sessionStorage.removeItem('backEnroll' + _this.id);
            _this.huifu = true;
          })
          .catch(() => {
            // on cancel
            sessionStorage.removeItem('backEnroll' + _this.id);
          });
      }

    },
    methods: {
      //权限验证
      adminMerber() {
        var _this = this;
        let url = "/ac1/conference/memberInfo";
        let params = {};
        _this.$get(url, params).then(res => {
          if (res.code == 1) {
            _this.adminShow = true;
          } else {
            _this.$dialog.alert({
              title: '提示',
              message: res.msg,
            }).then(() => {
              // on close
            });
          }
        });
      },
      //自定义下拉点击
      showZdybox(i, n, s) {
        var _this = this;
        var boxs = _this.cartbox.conf_ticket_arr[i].member[n].filed[s];
        var filed_box = _this.field_box[s];
        _this.zdybox.radio = boxs.value;
        _this.zdybox.value = boxs.value;
        _this.zdybox.list = filed_box.options;
        _this.zdybox.inputOn = [i, n, s];
        _this.zdybox.placeholder = filed_box.tips;
        _this.zdybox.show = true;
        if (boxs.value) {
          _this.zdySearchKeyUp();
        }
      },
      //自定义字段搜索下拉
      zdySearchKeyUp() {
        var _this = this;
        var inputText = _this.zdybox.value;
        var list = _this.field_box[_this.zdybox.inputOn[2]].options;
        _this.zdybox.radio = '';
        _this.zdybox.list = [];
        var zhi = '';
        for (var i = 0; i < list.length; i++) {
          zhi = list[i];
          if (zhi.indexOf(inputText) != -1) { //因为indexof找不到的时候是一律为-1，所以直接判断是否为-1，不是就弹出这个值
            _this.zdybox.list.push(list[i]); //将值放入第二个数组
          }
        }
      },
      //自定义字段搜索保存
      zdyBaocun() {
        var _this = this;
        if (_this.zdybox.radio === '') {
          _this.$toast('请选择选项！');
          return false;
        }
        _this.cartbox.conf_ticket_arr[_this.zdybox.inputOn[0]].member[_this.zdybox.inputOn[1]].filed[_this.zdybox.inputOn[2]].value = _this.zdybox.radio;
        _this.cartbox.conf_ticket_arr[_this.zdybox.inputOn[0]].member[_this.zdybox.inputOn[1]].filed[_this.zdybox.inputOn[2]].is_required = true;
        _this.cartbox.conf_ticket_arr[_this.zdybox.inputOn[0]].member[_this.zdybox.inputOn[1]].filed[_this.zdybox.inputOn[2]].is_click = true;
        _this.zdybox.show = false;
      },
      //设置唯一主要联系人
      changeZy(s, n) {
        var _this = this;
        for (var i = 0; i < _this.cartbox.conf_ticket_arr.length; i++) {
          var member = _this.cartbox.conf_ticket_arr[i].member;
          for (var j = 0; j < member.length; j++) {
            if (i == s) {
              if (j != n) {
                _this.cartbox.conf_ticket_arr[i].member[j].main = false;
              } else {
                _this.cartbox.conf_ticket_arr[i].member[j].main = true;
              }
            } else {
              _this.cartbox.conf_ticket_arr[i].member[j].main = false;
            }
          }
        }
      },
      // 校验函数返回 true 表示校验通过，false 表示不通过
      validator(i, n, s) {
        var _this = this;
        var car_filed = _this.cartbox.conf_ticket_arr[i].member[n].filed[s];
        var filed_box = _this.field_box[s];
        var regular = new RegExp(filed_box.pattern);
        if (filed_box.is_required) {
          if (filed_box.form_type == 7) {
            if (car_filed.value.length > 0) {
              car_filed.is_click = true;
              car_filed.is_required = true;
            } else {
              _this.$toast('请选择' + filed_box.field);
            }
            return false;
          }
          if (car_filed.value.length >= filed_box.minlength && car_filed.value.length <= filed_box.maxlength) {
            if (!(regular.test(car_filed.value))) {
              car_filed.is_click = false;
              car_filed.is_required = false;
              _this.$toast(_this.field_box[s].errortips);
              return false;
            } else {
              car_filed.is_click = true;
              car_filed.is_required = true;
            }
          } else {
            if (car_filed.value.length > 0) {
              _this.$toast(filed_box.field + '输入长度为' + filed_box.minlength + ' - ' + filed_box.maxlength + '个字符');
            } else {
              _this.$toast('请输入' + filed_box.field);
            }
            car_filed.is_click = false;
            car_filed.is_required = false;
            return false;
          }
        } else {
          if (car_filed.value != '') {
            if (!(regular.test(car_filed.value))) {
              car_filed.is_click = false;
              car_filed.is_required = false;
              _this.$toast(_this.field_box[s].errortips);
              return false;
            } else {
              car_filed.is_click = true;
              car_filed.is_required = true;
            }
          }
        }
      },
      checkedChang(i, n, s) {
        var _this = this;
        var car_filed = _this.cartbox.conf_ticket_arr[i].member[n].filed[s];
        var filed_box = _this.field_box[s];
        if (filed_box.is_required) {
          if (filed_box.form_type == 4) {
            if (car_filed.value.length == 0) {
              car_filed.is_click = false;
              car_filed.is_required = false;
              _this.$toast(_this.field_box[s].errortips);
              return false;
            } else {
              car_filed.is_click = true;
              car_filed.is_required = true;
            }
          } else {
            if (car_filed.value == '') {
              car_filed.is_click = false;
              car_filed.is_required = false;
              if (_this.cartbox.conf_ticket_arr[i].member[n].chuban == 0) {
                _this.$toast('请选择' + car_filed.name);
              } else {
                _this.$toast('请输入' + car_filed.name);
              }
              return false;
            } else {
              car_filed.is_click = true;
              car_filed.is_required = true;
            }
          }
        }
        //判断是否已出版 展示内容
        if (filed_box.field == '是否已出版皮书') {
          if (!_this.huifu) {
            _this.delPishu(i, n);
          } else {
            _this.huifu = false;
          }
          _this.cartbox.conf_ticket_arr[i].member[n].chuban = '';
          if (car_filed.value == '已出版') {
            _this.cartbox.conf_ticket_arr[i].member[n].chuban = 0;
          } else if (car_filed.value == '拟出版') {
            _this.cartbox.conf_ticket_arr[i].member[n].chuban = 1;
          }
        }
      },
      //清空已输入出版的书名
      delPishu(i, n) {
        var _this = this;
        var box = _this.cartbox.conf_ticket_arr[i].member[n];
        for (var i = 0; i < _this.field_box.length; i++) {
          if (_this.field_box[i].form_type == 7) {
            box.filed[i].value = '';
          }
        }
      },
      //总结票价跟数量
      changPiao() {
        var _this = this;
        var conf_ticket_num = 0,
          parallel_ticket_num = 0,
          hotel_num = 0,
          repast_num = 0,
          conf_price = 0.00,
          parallel_price = 0.00,
          hotel_price = 0.00,
          repast_price = 0.00;
        _this.cartbox.conf_ticket_arr.forEach(v => {
          if (v.quantity > 0) {
            conf_ticket_num += v.quantity;
            conf_price += v.price * v.quantity;

          }
        });
        _this.cartbox.parallel_ticket_arr.forEach(s => {
          for (var i = 0; i < s.ticket.length; i++) {
            if (s.ticket[i].quantity > 0) {
              parallel_ticket_num += s.ticket[i].quantity;
              parallel_price += s.ticket[i].price * s.ticket[i].quantity;
            }
          }
        });
        _this.cartbox.hotel.forEach((s, p) => {
          for (var i = 0; i < s.list.length; i++) {
            if (s.list[i].quantity > 0) {
              var day = 0;
              for (var j = 0; j < s.list[i].quantity; j++) {
                day += s.list[i].people_list[j].day;
              }
              _this.cartbox.hotel[p].list[i].day = day;
              hotel_num += s.list[i].quantity;
              hotel_price += s.list[i].price * day;
            }
          }
        });
        _this.cartbox.repast.forEach(s => {
          if (s.quantity > 0) {
            repast_num += s.quantity;
            repast_price += s.price * s.quantity;
          }
        });
        _this.cartbox.carNumPrice.conf_ticket_num = conf_ticket_num;
        _this.cartbox.carNumPrice.parallel_ticket_num = parallel_ticket_num;
        _this.cartbox.carNumPrice.hotel_num = hotel_num;
        _this.cartbox.carNumPrice.repast_num = repast_num;
        _this.cartbox.carNumPrice.conf_price = conf_price;
        _this.cartbox.carNumPrice.parallel_price = parallel_price;
        _this.cartbox.carNumPrice.hotel_price = hotel_price;
        _this.cartbox.carNumPrice.repast_price = repast_price;
        if (_this.parallel.isIn == '0') {
          parallel_price = 0;
          parallel_ticket_num = 0;
        }
        if (_this.hotel.isIn == '0') {
          hotel_price = 0;
          hotel_num = 0;
        }
        if (_this.repast.isIn == '0') {
          repast_num = 0;
          repast_price = 0;
        }
        _this.cartbox.carNumPrice.price = (conf_price + parallel_price + hotel_price + repast_price).toFixed(2);
        _this.cartbox.carNumPrice.num = conf_ticket_num + parallel_ticket_num;
        var conts = {
          id: _this.id,
          conference: _this.conference,
          cartbox: _this.cartbox
        };
        sessionStorage.setItem('huiyi_orderlist' + _this.id, JSON.stringify(conts));
      },
      //修改票数
      change(e) {
        var _this = this;
        /*  if(e.quantity == e.max_num){
            _this.$toast('此门票最多只能购买 '+e.max_num+' 张！');
          }
          if(e.remaining_num-e.quantity == 0){
            _this.$toast('没有了！');
          }*/
        _this.changPiao();
      },
      overlimit(val) {
        /*  console.log(val);*/
        var _this = this;
        if (val.quantity == val.max_num) {
          if (val.quantity == val.remaining_num) {
            _this.$toast('没有名额了！');
          } else {
            _this.$toast('此活动限制单用户报名数量， 当前您最多可选数量为 ' + val.max_num);
            //  _this.$toast('一个用户一场活动最多可购买 '+val.limit_number+' 张！');
          }

        }
      },
      //酒店展开关闭
      hotelClick(index) {
        var _this = this;
        _this.cartbox.hotel[index].isShow == 1 ? _this.cartbox.hotel[index].isShow = 0 : _this.cartbox.hotel[index].isShow = 1;
      },
      //酒店房间加减
      hoteladd(i, n) {
        var _this = this;
        const nums = _this.cartbox.carNumPrice;

        var jsons = {
          id: _this.cartbox.hotel[i].list[n].id,
          type: 21,
          name1: '',
          is_required: true,
          name2: '',
          start_time: _this.cartbox.hotel[i].list[n].start_time,
          end_time: _this.cartbox.hotel[i].list[n].end_time,
          day: Math.floor((_this.cartbox.hotel[i].list[n].end_time - _this.cartbox.hotel[i].list[n].start_time) / (24 * 3600)),
          conference_id: _this.id
        };
        _this.cartbox.hotel[i].list[n].people_list.push(JSON.parse(JSON.stringify(jsons)));

        if (nums.hotel_num >= nums.num) {
          _this.$toast('酒店房间数量不能超过会议门票数量!');
          setTimeout(function() {
            _this.cartbox.hotel[i].list[n].quantity = _this.cartbox.hotel[i].list[n].quantity - 1;
            _this.hotelRem(i, n);
          }, 100)
        }

      },
      hotelRem(i, n) {
        var _this = this;
        if (_this.cartbox.hotel[i].list[n].people_list.length > 0) {
          var day = 0;
          for (var h = 0; h < _this.cartbox.hotel[i].list[n].people_list.length; h++) {
            day += _this.cartbox.hotel[i].list[n].people_list[h].day;
          }
          _this.cartbox.hotel[i].list[n].day = _this.cartbox.hotel[i].list[n].day - day;
          _this.cartbox.hotel[i].list[n].people_list.pop();
        }
      },
      //酒店入驻人
      nameChange(i, n, s) {
        var _this = this;
        var hotel = _this.cartbox.hotel[i].list[n].people_list[s];
        if (hotel.name1 == '') {
          hotel.is_required = false;
          _this.$toast('请填写住宿人姓名');
        } else {
          hotel.is_required = true;
        }
      },
      //banner跳转方法
      goPath(path) {
        this.$router.push(path)
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      //加载初始化内容
      loadEnroll() {
        var _this = this;
        let url = ["/ac1/conference/enrollField", '/ac1/conference/chooseTickets'];
        let params = [{
          id: _this.id
        }, {
          id: _this.id
        }];
        var getStorage = JSON.parse(sessionStorage.getItem('huiyi_orderlist' + _this.id));
        _this.$get(url[0], params[0]).then(res => {
          if (res.code == "1") {
            var piao_num = 0;
            _this.field_box = res.posts;
            _this.cartbox.conf_ticket_arr.forEach(v => {
              var _thisNum = v.quantity - v.member.length;
              var filed = [];
              _this.field_box.forEach(s => {
                var val = '';
                if (s.form_type == 4) {
                  val = [];
                }
                if (s.form_type == 6) {
                  val = '';
                }
                var is_required = false;
                if (s.is_required == 0) {
                  is_required = true;
                }
                var list = {
                  id: s.id,
                  name: s.field,
                  field_name: s.field_name,
                  value: val,
                  is_required: is_required,
                  is_click: true
                }
                filed.push(list);
              });
              for (var i = 0; i < _thisNum; i++) {
                var filed = JSON.parse(JSON.stringify(filed));
                piao_num += 1;
                v.member.push({
                  piao_num: piao_num,
                  name: filed[0].value,
                  tel: filed[1].value,
                  filed: filed,
                  main: false,
                  chuban: '' //是否出版选择单加
                });
              }
            });
            _this.field_box.forEach(s => {
              if (s.form_type == 5) {
                var optionslist = [];
                for (var i = 0; i < s.options.length; i++) {
                  optionslist.push({
                    text: s.options[i],
                    value: s.options[i]
                  });
                }
                s.options = optionslist;
              }
            });
          }
        });
        _this.$get(url[1], params[1]).then(res => {
          if (res.code == "1") {
            var getStorage2 = getStorage.cartbox;

            _this.parallel.list = res.posts.conference;
            for (var p = 0; p < _this.parallel.list.length; p++) {
              var v = _this.parallel.list[p];
              var list = [];
              for (var i = 0; i < v.ticket.length; i++) {
                list.push({
                  id: v.ticket[i].ticket_id,
                  name: v.ticket[i].ticket_name,
                  price: v.ticket[i].price,
                  quantity: 0,
                  remaining_num: (v.ticket[i].number - v.ticket[i].sold_num),
                  max_num: ((v.ticket[i].limit_number - v.ticket[i].buy_num) >= (v.ticket[i].number - v.ticket[i].sold_num) ? (v.ticket[i].number - v.ticket[i].sold_num) : (v.ticket[i].limit_number - v.ticket[i].buy_num)),
                  limit_number: v.ticket[i].limit_number,
                  buy_num: v.ticket[i].buy_num,
                  type: 20
                });
              }
              for (var h = 0; h < getStorage2.parallel_ticket_arr.length; h++) {
                if (getStorage2.parallel_ticket_arr[h].id == v.parallel_id) {
                  list = getStorage2.parallel_ticket_arr[h].ticket;
                }
              }
              _this.cartbox.parallel_ticket_arr.push({
                id: v.parallel_id,
                ticket: JSON.parse(JSON.stringify(list))
              });
            }
            if (getStorage2.carNumPrice.conf_ticket_num == 0) {
              _this.parallel.list = [];
            }
            //酒店信息数据转化
            var box1 = [],
              box2 = []; //box2 酒店信息储存
            for (var i = 0; i < res.posts.hotel.length; i++) {
              var indexs = box1.indexOf(res.posts.hotel[i].hotel_info.hotel_id);
              var indexbox = res.posts.hotel[i];
              var box3 = {
                end_time: indexbox.hotel_info.end_time,
                explain: indexbox.hotel_info.explain,
                hotel_type: indexbox.hotel_info.hotel_type,
                id: indexbox.hotel_info.id,
                price: indexbox.hotel_info.price,
                quantity: indexbox.quantity,
                sold_num: indexbox.sold_quantity,
                start_time: indexbox.hotel_info.start_time,
              };
              if (indexs != -1) {
                box2[indexs].room.push(box3)
              } else {

                box1.push(res.posts.hotel[i].hotel_info.hotel_id);
                box2.push({
                  name: indexbox.hotel_info.h_name,
                  conference_id: indexbox.conference_id,
                  hotel_id: indexbox.hotel_info.hotel_id,
                  room: [box3]
                });
              }
            }
            //酒店信息赋值
            _this.hotel.list = box2;
            var nums = 1;
            if (_this.cartbox.hotel.length < _this.hotel.list.length) {
              _this.hotel.list.forEach(v => {
                var list = [];
                for (var i = 0; i < v.room.length; i++) {
                  list.push({
                    id: v.room[i].id,
                    name: v.room[i].hotel_type,
                    max_num: (v.room[i].quantity - v.room[i].sold_num),
                    min_date: v.room[i].start_time,
                    max_date: v.room[i].end_time,
                    price: v.room[i].price,
                    quantity: 0,
                    remaining_num: (v.room[i].quantity - v.room[i].sold_num),
                    people_list: [],
                    day: '',
                    end_time: v.room[i].end_time,
                    start_time: v.room[i].start_time,
                  });
                }

                _this.cartbox.hotel.push({
                  hotel_id: v.hotel_id,
                  isShow: nums,
                  list: list
                });
                nums = 0;
              });
            }
            _this.repast.list = res.posts.repast;
            if (_this.cartbox.repast.length < _this.repast.list.length) {
              _this.repast.list.forEach(v => {
                _this.cartbox.repast.push({
                  id: v.repast_info.id,
                  conference_id: _this.id,
                  name: v.repast_info.address,
                  price: v.repast_info.price,
                  quantity: 0,
                  remaining_num: (v.quantity - v.sold_quantity),
                  type: 22
                });
              });
            }
          }
        });
      },
      show_orderBox() {
        this.order_show = !this.order_show;
      },
      formatDate(date) {
        return `${date.getFullYear()} - ${date.getMonth() + 1} - ${date.getDate()}`;
      },
      //日期选择
      open_datetimePicker(i, n) {
        var _this = this;
        _this.datetimePicke.show = true;
        if (_this.cartbox.conf_ticket_arr[i[0]].member[i[1]].filed[i[2]].value != '') {
          _this.datetimePicke.default_date = new Date(_this.cartbox.conf_ticket_arr[i[0]].member[i[1]].filed[i[2]].value);
        } else {
          _this.datetimePicke.default_date = new Date();
        }
        _this.datetimePicke.isOndata = _this.cartbox.conf_ticket_arr[i[0]].member[i[1]].filed[i[2]];
      },
      //确认选择日期
      datetimePickerConfirm(date) {
        var _this = this;
        _this.datetimePicke.show = false;
        _this.datetimePicke.isOndata.value = _this.$options.filters['formatDates'](date / 1000, 'Y/M/D h:m');
        _this.datetimePicke.isOndata.is_click = true;
        _this.datetimePicke.isOndata.is_required = true;
      },
      //关闭选择日期
      onCancel() {
        this.datetimePicke.show = false;
      },
      //日历选择器展示
      open_calendar(i, n) {
        var _this = this;
        _this.vanCalendar.v_model = true;
        _this.vanCalendar.type = n.type;
        _this.vanCalendar.default_date = [new Date(n.default_date[0] * 1000), new Date(n.default_date[1] * 1000)];
        _this.vanCalendar.max_range = n.max_range;
        _this.vanCalendar.isOndata = _this.cartbox.hotel[i[0]].list[i[1]].people_list[i[2]];
        _this.vanCalendar.min_date = new Date(_this.cartbox.hotel[i[0]].list[i[1]].min_date * 1000);
        _this.vanCalendar.max_date = new Date(_this.cartbox.hotel[i[0]].list[i[1]].max_date * 1000);
      },
      //日历选择完1
      calendar_confirm(e) {
        // console.log(e);
        var _this = this;
        _this.vanCalendar.v_model = false;
        _this.vanCalendar.isOndata.start_time = parseInt(new Date(e[0]).getTime() / 1000);
        _this.vanCalendar.isOndata.end_time = parseInt(new Date(e[1]).getTime() / 1000);
        _this.vanCalendar.isOndata.day = (new Date(e[1]).getTime() - new Date(e[0]).getTime()) / (24 * 3600 * 1000);
        _this.changPiao();
      },

      //提交订单
      addPiaoCont() {
        var _this = this;
        var status = true;
        var conf_ticket_arr = [],
          parallel_ticket_arr = [],
          hotel = [],
          repast = [];
        var myreg= /^[1][0-9]{10}$/;
        if(!myreg.test(_this.addUserPhone)) {
          _this.$toast('请输入正确的订单归属人手机号！');
          return false;
        }
        //主会议门票
        for (var i = 0; i < _this.cartbox.conf_ticket_arr.length; i++) {
          var lists = _this.cartbox.conf_ticket_arr[i];
          if (lists.quantity > 0) {
            conf_ticket_arr.push(lists);
          }
          for (var j = 0; j < lists.member.length; j++) {
            var lists2 = lists.member[j];
            lists2.name = lists2.filed[0].value;
            lists2.tel = lists2.filed[1].value;
            for (var h = 0; h < lists2.filed.length; h++) {
              var filedbox = _this.cartbox.conf_ticket_arr[i].member[j].filed[h];
              if (!filedbox.is_required) {
                if (_this.field_box[h].form_type == 1 || _this.field_box[h].form_type == 2) {
                  _this.validator(i, j, h);
                } else {
                  _this.checkedChang(i, j, h);
                }
                filedbox.is_click = false;
                status = false;
                return false;
              }
            }
          }
        }
        //酒店
        if (_this.hotel.isIn != '0') {
          for (var i = 0; i < _this.cartbox.hotel.length; i++) {
            var lists = _this.cartbox.hotel[i];
            for (var j = 0; j < lists.list.length; j++) {
              var lists2 = lists.list[j];
              for (var h = 0; h < lists2.people_list.length; h++) {
                var hotelbox = _this.cartbox.hotel[i].list[j].people_list[h];
                hotel.push(hotelbox);
                if (hotelbox.name1 == '') {
                  hotelbox.is_required = false;
                  _this.$toast('请填写住宿人姓名');
                  status = false;
                  return false;
                }
              }
            }
          }
        }
        if (_this.parallel.isIn != '0') {
          //平行会议
          for (var i = 0; i < _this.cartbox.parallel_ticket_arr.length; i++) {
            var lists = _this.cartbox.parallel_ticket_arr[i];
            for (var j = 0; j < lists.ticket.length; j++) {
              var lists2 = lists.ticket[j];
              var parallelbox = _this.cartbox.parallel_ticket_arr[i].ticket[j];
              if (parallelbox.quantity > 0) {
                parallel_ticket_arr.push(parallelbox);
              }
            }
          }
        }
        if (_this.repast.isIn != '0') {
          //是否用餐
          for (var i = 0; i < _this.cartbox.repast.length; i++) {
            var lists = _this.cartbox.repast[i];
            if (lists.quantity > 0) {
              repast.push(lists);
            }
          }
        }
        var dep_id = '';
        if (_this.conference.is_dep) {
          if (_this.bumenOn === '') {
            _this.$toast('请选择联系部门！');
            status = false;
          } else {
            dep_id = _this.bumen[_this.bumenOn].id;
          }
        }
        var noHotel = '';
        if (hotel.length == 0 && _this.hotel.list.length > 0) {
          noHotel = '您没有选择酒店房间，点击“取消”后可以去选择酒店房间，';
        }
        if (status) {
          _this.$dialog.confirm({
            message: noHotel + '点击“确认”后将提交报名信息。',
          }).then(() => {
            // on close
            sessionStorage.removeItem('huiyi_orderlist' + _this.id);
            sessionStorage.setItem('backEnroll' + _this.id, JSON.stringify({
              cartbox: _this.cartbox,
              bumenOn: _this.bumenOn
            }));
            let url = "/ac1/conference/admin/enroll";
            let params = {
              conf_ticket_arr: conf_ticket_arr,
              parallel_ticket_arr: parallel_ticket_arr,
              repast: repast,
              hotel: hotel,
              conference_id: _this.id,
              dep_id: dep_id,
              member_phone:_this.addUserPhone
            };
            console.log(params);
            _this.$post(url, params).then(res => {
              if (res.code == "1") {
                console.log(res);
                if (res.msg == '成功！') {
                  parent.location.reload();
                }
              } else {
                //判断字数 提示框样式
                if (res.msg.length > 20) {
                  _this.$dialog({
                    title: '提示',
                    message: res.msg
                  });
                } else {
                  _this.$toast(res.msg);
                }
              }
            }, function(res) {
              _this.$toast(res.msg);
            });
          }).catch(() => {
            // on cancel
          });
        }
      },
      getBumen() {
        var _this = this;
        let url = "/ac1/conference/auth/memberList";
        let params = {
          page: 0,
          pagesize: 0,
          type: ''
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            res.posts.forEach((val, index) => {
              _this.bumen.push({
                text: val.name,
                value: index,
                id: val.id
              });
            })
          } else {
            _this.$toast(res.msg);
          }
        }, function(res) {
          _this.$toast(res.msg);
        });
      },
      /*   beforeunloadFn(e) {
        e = e || window.event;
        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = "您是否确认离开此页面-您输入的数据可能不会被保存";
        }
        var _this = this; sessionStorage.setItem('backEnroll'+_this.id,JSON.stringify({cartbox:_this.cartbox,bumenOn:_this.bumenOn}));
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return "您是否确认离开此页面-您输入的数据可能不会被保存";
      }*/
    },
    mounted() {

    },
    beforeDestroy() {
      var _this = this;
      _this.$toast.clear();
      sessionStorage.setItem('backEnroll' + _this.id, JSON.stringify({
        cartbox: _this.cartbox,
        bumenOn: _this.bumenOn
      }));
    }
  }
</script>
<style lang="less" scoped>

</style>
